import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/logo2.png';

const _withScopeId = n => (_pushScopeId("data-v-bf90f69e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "login-container"
};
const _hoisted_2 = {
  class: "login-content"
};
const _hoisted_3 = {
  style: {
    "padding": "15px"
  }
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "flex",
    "justify-content": "center"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  style: {
    "width": "50px"
  }
})], -1));

const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  class: "form-label"
};
const _hoisted_7 = {
  class: "form-label",
  style: {
    "margin-top": "23px"
  }
};
const _hoisted_8 = {
  class: "strong"
};
const _hoisted_9 = {
  class: "tip"
};
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import NavGradient from '@/components/NavGradient.vue';
import LangChange from '@/components/LangChange.vue';
import { Toast } from 'vant';
import 'vant/es/toast/style';
import { loginApi } from '@/apis';
import { useI18n } from "vue-i18n";
import moment from 'moment';
import { encrypt, decrypt } from '@/util/saveAccount';
import GoogleCodeModal from '@/components/GoogleCodeModal.vue';
export default {
  __name: 'LoginView',

  setup(__props) {
    const {
      t,
      setLocaleMessage,
      locale
    } = useI18n();
    const router = useRouter();
    const store = useStore();
    const email = ref('');
    const password = ref('');
    const captcha = ref('123123');
    const loading = ref(false);
    const googleCodeShow = ref(false);
    const saveAccount = ref(false);

    const langSelect = lang => {
      localStorage.setItem('websetlang', lang);
      store.commit('langChange', lang);

      try {
        const msg = require(`@/language/lang/${lang}`).default;

        setLocaleMessage(lang, msg);
        locale.value = lang;
      } catch (err) {
        console.warn(err);
      }
    };

    onMounted(() => {
      const str = localStorage.getItem('astore_save');

      if (str && str !== '') {
        const data = decrypt(str);

        try {
          const msg = JSON.parse(data);
          email.value = msg.a ? msg.a : '';
          password.value = msg.m ? msg.m : '';
          saveAccount.value = true;
        } catch (err) {
          console.warn(err);
        }
      }
    });

    const submitLogin = async (gacode = '') => {
      loading.value = true;
      const data = {
        email: email.value.trim(),
        password: password.value
      };
      if (gacode) data.gacode = gacode;
      const res = await loginApi(data);
      loading.value = false;
      return res;
    };

    const loginSuccess = res => {
      if (res.token) {
        store.commit('tokenChange', res.token);
        store.commit('emailChange', email.value);
        store.commit('getStar');
        localStorage.setItem('astore_info', JSON.stringify({
          token: res.token,
          time: moment().unix(),
          email: email.value
        }));

        if (saveAccount.value) {
          const str = encrypt({
            a: email.value,
            m: password.value
          });
          localStorage.setItem('astore_save', str);
        } else {
          localStorage.removeItem('astore_save');
        }
      }

      Toast({
        message: t('loginSuccess'),
        position: 'bottom'
      });
      store.dispatch('refreshUserInfo');
      router.replace({
        name: 'home'
      });
    };

    const login = async () => {
      const res = await submitLogin();

      if (res.code === 402) {
        googleCodeShow.value = true;
        return;
      }

      if (res.code !== 200) {
        Toast({
          message: res.msg || t('loginError'),
          position: 'bottom'
        });
        return;
      }

      if (res.token) {
        loginSuccess(res);
      }
    };

    const confirmGoogleCode = async gacode => {
      const res = await submitLogin(gacode);

      if (res.code !== 200) {
        Toast({
          message: res.msg || t('loginError'),
          position: 'bottom'
        });
        return;
      }

      googleCodeShow.value = false;
      loginSuccess(res);
    };

    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");

      const _component_a_input_password = _resolveComponent("a-input-password");

      const _component_van_checkbox = _resolveComponent("van-checkbox");

      const _component_van_button = _resolveComponent("van-button");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(NavGradient, null, {
        default: _withCtx(() => [_createVNode(LangChange, {
          onSelect: langSelect
        })]),
        _: 1
      }), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('loginText')), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('loginEmail')), 1), _createVNode(_component_a_input, {
        style: {
          "height": "39px",
          "font-size": "15px"
        },
        allowClear: "",
        placeholder: _unref(t)('loginEmailInput'),
        value: email.value,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => email.value = $event)
      }, null, 8, ["placeholder", "value"]), _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('loginPwd')), 1), _createVNode(_component_a_input_password, {
        style: {
          "height": "39px",
          "font-size": "15px"
        },
        allowClear: "",
        placeholder: _unref(t)('loginPwdTip'),
        value: password.value,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => password.value = $event)
      }, null, 8, ["placeholder", "value"]), _createElementVNode("div", {
        class: "forgot",
        onClick: _cache[2] || (_cache[2] = $event => _unref(router).push({
          name: 'loginPwd'
        }))
      }, _toDisplayString(_unref(t)('forgotPassword')), 1), _createVNode(_component_van_checkbox, {
        modelValue: saveAccount.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => saveAccount.value = $event),
        shape: "square",
        "icon-size": "15",
        style: {
          "margin-top": "15px"
        },
        "checked-color": "#F08504"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('saveAccount')), 1)]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_van_button, {
        color: "#F08504",
        block: "",
        onClick: login,
        disabled: email.value === '' || password.value === '' || captcha.value === '',
        style: {
          "margin": "20px 0 20px 0",
          "--van-button-default-height": "44px",
          "font-size": "17px",
          "border-radius": "100px"
        },
        loading: loading.value
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('login')), 1)]),
        _: 1
      }, 8, ["disabled", "loading"]), _createElementVNode("div", {
        class: "register",
        onClick: _cache[4] || (_cache[4] = $event => _unref(router).replace({
          name: 'register'
        }))
      }, [_createElementVNode("span", null, _toDisplayString(_unref(t)('registerText')), 1), _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('registerText1')), 1)]), _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('loginPolicy')), 1)])])]), _createVNode(GoogleCodeModal, {
        show: googleCodeShow.value,
        loading: loading.value,
        onHide: _cache[5] || (_cache[5] = $event => googleCodeShow.value = false),
        onConfirm: confirmGoogleCode
      }, null, 8, ["show", "loading"])]);
    };
  }

};